/* eslint-disable */
import { memo } from 'react';
import * as S1 from './Section.styled';
import { useFormContext } from 'react-hook-form';
import { CustomInput } from 'components';

const inputWidth = 285;

export const SocialMediaSection = memo(() => {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  const handleChangeFieldValue = (field, value) => {
    setValue(`generalInformation.socialMedia.${field}`, value, { shouldDirty: true });
  };

  const getValue = (field) => {
    return watch(`generalInformation.socialMedia.${field}`) || '';
  };

  return (
    <S1.SectionBox style={{ marginTop: '32px' }}>
      <S1.Row>
        <S1.FieldName>Facebook</S1.FieldName>
        <CustomInput
          value={getValue('facebook')}
          autoComplete='off'
          id={`facebook`}
          name={`facebook`}
          onChange={(e) => {
            handleChangeFieldValue('facebook', e.target.value);
          }}
          width={inputWidth}
        />
      </S1.Row>
      <S1.Row>
        <S1.FieldName>twitter</S1.FieldName>
        <CustomInput
          value={getValue('twitter')}
          autoComplete='off'
          id={`twitter`}
          name={`twitter`}
          onChange={(e) => {
            handleChangeFieldValue('twitter', e.target.value);
          }}
          width={inputWidth}
        />
      </S1.Row>
      <S1.Row>
        <S1.FieldName>linkedIn</S1.FieldName>
        <CustomInput
          value={getValue('linkedIn')}
          autoComplete='off'
          id={`linkedIn`}
          name={`linkedIn`}
          onChange={(e) => {
            handleChangeFieldValue('linkedIn', e.target.value);
          }}
          width={inputWidth}
        />
      </S1.Row>
    </S1.SectionBox>
  );
});
